export default __webpack_public_path__ + "static/media/hefkraan.a2fef676.svg";